import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundImage:
      "linear-gradient(to right top, #520a65, #441252, #36163f, #29172d, #1b161c)",
    width: "100vw",
    color: theme.palette.text.primary,
  },
  form: {
    backgroundColor: theme.palette.common.white,
    padding: "50px 25px",
    borderRadius: "15px",
  },
  title: {
    fontWeight: "600 !important",
    marginBottom: "30px !important",
  },
  logo: {
    width: "50px",
  },
  input: {
    color: theme.palette.text.primary,
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.primary,
    },
  },
  button: {
    width: "100%",
    fontWeight: "700 !important",
    borderRadius: "50px !important",
  },
}));

export default useStyles;
